import type { IconData } from '@stacksjs/iconify-core'

export const callHangUpSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M29.23 25.695L10.768 7.232a2.5 2.5 0 0 0-3.536 3.536l36 36a2.5 2.5 0 0 0 3.536-3.536L38.536 35a32.86 32.86 0 0 0 7.947-20.444C46.597 7.361 41.796 1.5 34.431 1.5a4.5 4.5 0 0 0-4.178 2.829l-2.466 6.165a5.5 5.5 0 0 0 1.217 5.932l3.077 3.076c.136.136.152.289.124.382a18.4 18.4 0 0 1-2.975 5.81M13.5 46.5a32.85 32.85 0 0 0 19.212-6.166l-9.506-9.506a18.4 18.4 0 0 1-3.322 1.377c-.093.028-.246.012-.382-.124l-3.076-3.077a5.5 5.5 0 0 0-5.932-1.217l-6.165 2.466A4.5 4.5 0 0 0 1.5 34.431c0 6.734 5.167 12.069 12 12.069\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default callHangUpSolid
